import VueI18n from 'vue-i18n'
import Vue from "vue";

Vue.use(VueI18n)

const messages = {
    en: {
        home: {
            addReview: {
                addReview: 'add post',
                close: 'close',
                fieldIsNecessary: '* indicates required field',
                warmMessage: 'please tell us how your experience was *'
            }
        },
        frame: {
            language: 'שנה לעברית',
        },
        login: {
            emailLabel: 'mail address',
            passwordLabel: 'password',
            close: 'close window',
            login: 'login',
            forgotPassword: 'forgotPassword'

        },
        search: {
            twoWay: 'two way',
            oneWay: 'one way',
            from: 'from',
            to: 'to',
            startDate: 'start date',
            endDate: 'end date',
            find: 'find now',
            passengers: 'pass',
            stops: 'stops'
        },
        updateFlight: {
            save: "save",
            updateFlight: "Update Flight",
            price: "price",
            changePrice: "change Price",
            refundPercentage: "refund Percentage",
            changeRefundPercentage: "change Refund Percentage",
            refundType: "Refund type",
            changeRefundType: "change refund type"
        },
        weather: {
            firstButton: 'weather info',
            closeButton: 'close',
            searchButton: 'search',
            firstTitle: 'search weather by location',
            secondTitle: 'weather result',
            cityTitle: 'city',
            backButton: 'back',
            date: 'date: ',
            tempeture: 'temperature: ',
        }
    },
    he: {
        home: {
            addReview: {
                addReview: 'להוסיף פוסט',
                close: 'סגור',
                fieldIsNecessary: '* מסמן שדה חובה',
                warmMessage: 'שתף את התחושות שלך*'
            }

        },
        frame: {
            language: 'change to english',
        },
        login: {
            emailLabel: 'כתובת מייל',
            passwordLabel: 'סיסמא',
            close: 'סגור חלון',
            login: 'התחבר',
            forgotPassword: 'שכחתי סיסמה'
        },
        search: {
            twoWay: 'הלוך חזור',
            oneWay: 'כיוון אחד',
            from: '?מאיפה',
            to: '?לאן',
            startDate: 'תאריך יציאה',
            endDate: 'תאריך חזרה',
            find: 'חפש עכשיו',
            passengers: 'נוסעים',
            stops: 'עצירות'
        },
        updateFlight: {
            save: "שמור",
            updateFlight: "עדכון טיסה",
            price: "מכיר",
            changePrice: "לשנות מכיר",
            refundPercentage: "אחוז החזר",
            changeRefundPercentage: "לשנות אחוז החזר",
            refundType: "סוג החזר",
            changeRefundType: "לשנות סוג החזר "
        },
        weather: {
            firstButton: 'מידע מזג האוויר',
            closeButton: 'סגור',
            searchButton: 'חיפוש',
            firstTitle: 'חפש מידע על מזג האוויר לפי מיקום ותאריך',
            secondTitle: 'מזג האוויר תוצאה',
            cityTitle: 'עיר',
            backButton: 'חזור',
            date: 'תאריך: ',
            tempeture: 'טמפרטורה: '
        }
    }
}

export default new VueI18n({
    locale: 'he',
    messages,
})